import { EdgeData } from "./EdgeData";

/**
 * Edge holds generic Edge data to work with Graph.js.
 */
export class Edge {
    source;
    destination;
    data;

    constructor() {}

    /**
     * build new Edge from params
     * @param {string} source source node name
     * @param {string} destination destination node name
     * @param {EdgeData} data
     */
    static build(source, destination, data) {
        let instance = new Edge();
        instance.source = source;
        instance.destination = destination;
        instance.data = data;
        return instance;
    }

    getSource() {
        return this.source;
    }

    getDestination() {
        return this.destination;
    }

    getData() {
        return this.data;
    }

    /**
     * output edge in a way that works well with the Cirt front end
     * If this Edge class is to be used in other classes, then this function should be moved into EdgeData
     * @return {Object}
     */
    getEdgeWithData() {
        return {
            source: this.source,
            target: this.destination,
            ...this.getData()
        }
    }

    toJSON() {
        return {
            source: this.source,
            destination: this.destination,
            data: this.data
        };
    }

    static jsonDeserialize(jsonString) {
        let data = jsonString;
        let instance = new Edge();
        instance.source = data.source;
        instance.destination = data.destination;
        instance.data = EdgeData.jsonDeserialize(data.data);
        return instance;
    }
}